/**
 * NT-VIERTEL-07-FEINSCHLIFF (B1) — reine Sortierlogik für die Präsenz-Aktionsleiste
 * (ZEIGEN/TAGS/PARTY/SPAEHER), ausgelagert für Testbarkeit (Muster: pages/dashboard.betriebe-
 * shortcuts.ts, pages/business/crimeOps.categories.ts — reine Logik lebt in einer eigenen,
 * kleinen Datei statt im großen Tab-Modul, das Frontend-Vitest-Setup deckt kein DOM/
 * Component-Testing ab).
 */

export type PresenceActionKey = 'ZEIGEN' | 'TAGS' | 'PARTY' | 'SPAEHER';

const PRESENCE_ACTION_KEYS: PresenceActionKey[] = ['ZEIGEN', 'TAGS', 'PARTY', 'SPAEHER'];

/**
 * Buttons immer nach Kosten aufsteigend von links nach rechts, aus den vom Server gelieferten
 * costsCents berechnet — keine feste Definitionsreihenfolge, damit eine künftige Balance-
 * Änderung der Kosten die Reihenfolge automatisch mitzieht.
 */
export function getSortedActions(costsCents: Record<PresenceActionKey, string>): PresenceActionKey[] {
  return PRESENCE_ACTION_KEYS
    .slice()
    .sort((a, b) => Number(costsCents[a]) - Number(costsCents[b]));
}
